import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { AutocompleteOption } from '@types'

type ResetObjectValueOnValueNameChangeOptions = {
  watchedValueName: AutocompleteOption | null
  objectValueInputName: string
  fieldTypeInputName: string
  formatDateInputName: string
  objectValuePathArrayName: string
}

export const useResetValuesOnValueNameChange = ({
  watchedValueName,
  objectValueInputName,
  fieldTypeInputName,
  formatDateInputName,
  objectValuePathArrayName,
}: ResetObjectValueOnValueNameChangeOptions) => {
  const {
    setValue,
    formState: { isDirty },
  } = useFormContext()

  useEffect(() => {
    if (isDirty) {
      setValue(objectValueInputName, '')
      setValue(fieldTypeInputName, null)
      setValue(formatDateInputName, null)
      setValue(objectValuePathArrayName, [])
    }
  }, [watchedValueName])
}
